<template>
  <div class="card modal-card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h3 class="title is-size-3">
            {{ $t('listeMaterielTlpe.popup.listeFaces.title',
              {codeMateriel: materiel.code, disposition: materiel.disposition}) }}
          </h3><br />
        </div>
      </div>
    </div>
    <div class="modal-card-body pdt-0">
      <div class="card-content">
        <b-table :data="materiel.faces" :bordered="true" :striped="true">
          <b-table-column field="code"
                          v-slot="props"
                          :label="$t('listeMaterielTlpe.popup.listeFaces.code')">
            {{ props.row.code }}
          </b-table-column>
          <b-table-column field="etat"
                          v-slot="props"
                          :label="$t('listeMaterielTlpe.popup.listeFaces.etat')">
            {{ $t(getEtatMontage(props.row.etat)) }}
          </b-table-column>
          <b-table-column field="dateMontage"
                          v-slot="props"
                          :label="$t('listeMaterielTlpe.popup.listeFaces.dateMontage')">
            {{props.row.dateMontage | formatDate }}
          </b-table-column>
          <b-table-column field="dateDemontage"
                          v-slot="props"
                          :label="$t('listeMaterielTlpe.popup.listeFaces.dateDemontage')">
            {{props.row.dateDemontage | formatDate }}
          </b-table-column>
          <b-table-column field="declarable"
                          v-slot="props"
                          :label="$t('listeMaterielTlpe.popup.listeFaces.declarable')">
            <div class="has-text-centered">
              <b-checkbox disabled :value="props.row.declarableEnMairie"/>
            </div>
          </b-table-column>
          <b-table-column field="actif"
                          v-slot="props"
                          :label="$t('listeMaterielTlpe.popup.listeFaces.archivee')">
            <div class="has-text-centered">
              <b-checkbox disabled :value="!props.row.actif"/>
            </div>
          </b-table-column>
        </b-table>
      </div>
      <footer class="mgt-20px">
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.close')}}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

import {
  ETAT_DISPOSITIF_PUBLICITAIRE,
} from '@/configuration/gabed/dispositif/dispositifPublicitaire';

export default {
  props: {
    materiel: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getEtatMontage(codeEtat) {
      const etatFind = ETAT_DISPOSITIF_PUBLICITAIRE.find((etat) => {
        return etat.value === codeEtat;
      });
      return etatFind ? etatFind.libelle : null;
    },
  },
};
</script>
